import { Injectable } from '@angular/core';
import { Slide } from 'src/app/carousel/carousel.interface';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  // A HashMap to store the cache. The key is the page and the value is the data.
  private cache = new Map<string, Slide[]>();

  // The 'set' method for storing data in the cache.
  set(key: string, data: Slide[]) {
    // We check if data already exists for this key.
    if (this.cache.has(key)) {
      // If it already exists, we throw an exception to prevent overwriting the data.
    //   throw new Error(`Data already exists for key '${key}'. Use a different key or delete the existing one first.`);
    }
    else {
        this.cache.set(key, data);
    }
  }

  // The 'get' method for retrieving data from the cache.
  get(key: string) {
    
    // We retrieve the data from the cache and update the BehaviorSubject.
    const data = this.cache.get(key);
    return data;
  }

  // The 'clear' method to clear data from the cache.
  clear(key: string) {
    // We remove the data from the cache and update the BehaviorSubject.
    this.cache.delete(key);
  }
}